<template>
  <div>
    <v-dialog
        class="hide-on-print"
        v-model="specialCasePaymentDialog"
        persistent
        width="800">

      <v-card class="hide-on-print">
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Special Case Payment</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md class="pb-0">
            <v-layout wrap>
              <FormErrorDisplayHandler :errors="errors"/>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="manualRef">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                          label="Visa Number"
                          outlined
                          v-model="paymentData.visa_number"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                          label="Title *"
                          :rules="[rules.required]"
                          outlined
                          v-model="paymentData.title"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                          label="Revenue Type *"
                          outlined
                          :rules="[rules.required]"
                          :items="revenueTypes"
                          v-model="paymentData.type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                          ref="menu"
                          v-model="startDateMenu"
                          :close-on-content-click="false"
                          :return-value.sync="paymentData.revenue_date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="paymentData.revenue_date"
                              :rules="[rules.required]"
                              label="Revenue Date *"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="paymentData.revenue_date"
                            no-title
                            scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(paymentData.revenue_date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 class="pr-2">
                      <v-text-field
                          label="Amount (USD) *"
                          outlined
                          type="number"
                          v-model="usdAmount"
                          :rules="[rules.required]"
                          :error-messages="errorMessage"
                          onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                          label="Amount (NPR) *"
                          outlined
                          type="number"
                          :hint="'Exchange rate of NPR '+npr_rate"
                          v-model="nprAmount"
                          :rules="[rules.required]"
                          :error-messages="errorMessage"
                          onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                          label="Remarks"
                          outlined
                          v-model="paymentData.remarks"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <multiple-file-upload v-model="paymentData.files"
                                            label="Files (If any)"
                      />
                    </v-flex>


                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider style="margin-top:31px;"/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="cancel"
              class="white--text"
              color="red darken-3"
              :loading="loading"
          >Cancel
          </v-btn>
          <v-btn
              @click="save"
              class="white--text"
              color="blue darken-3"
              :loading="loading"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="spcResponseDialog" width="470">
      <v-card>
        <v-card-title class="title blue darken-3 white--text" default-title>Voucher Generated
        </v-card-title>
        <!--                <v-card-subtitle class="blue darken-3 white&#45;&#45;text pb-2" default-title>({{ visa_request.condition }})-->
        <!--                </v-card-subtitle>-->
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-list-item-content class="py-0">
                  <v-list-item-subtitle style="font-size: 12px;user-select: text;">Unique Id
                    (Auto Generated)
                  </v-list-item-subtitle>
                  <v-list-item-title
                      style="font-size: 21px; user-select: text;color: black; font-weight: bold">
                    {{ voucherDetail.submission_no }}
                  </v-list-item-title>
                  <v-list-item-subtitle style="font-size: 12px;user-select: text;">Voucher Number
                  </v-list-item-subtitle>
                  <v-list-item-title
                      style="font-size: 21px; user-select: text;color: black; font-weight: bold">
                    {{ voucherDetail.voucher_no }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                      style="font-size: 14px;margin-top: 10px;user-select: text;color: red">
                    Please, write down unique id carefully for future reference
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="!voucherDetail.voucher_no"
                                        style="font-size: 14px;margin-top: 10px;user-select: text;color: red">
                    Voucher not generated. please proceed manually
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="success"
              class="white--text"
              @click="spcResponseDialog = false"
          >Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import MultipleFileUpload from "../MultipleFileUpload";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import {mapGetters} from 'vuex';
import debounce from 'lodash/debounce';

export default {
  name: "SpecialCasePaymentDialog",
  components: {MultipleFileUpload, FormErrorDisplayHandler},
  props: ['travellerId', "paymentRef", "amount"],
  mixins: [validationMixin],

  data() {
    return {
      startDateMenu:false,
      paymentData: {},
      innerOpen: false,
      errorMessage: '',
      npr_rate: null,
      errors: [],
      usdAmount: '',
      nprAmount: '',
      revenueTypes: [
        {
          text: "Visa Fee",
          value: "visa_fee"
        },
        {
          text: "Penalty",
          value: "penalty"
        },
        {
          text: "Trekking Fee",
          value: "trekking"
        }
      ],
      loading: false,
      spcResponseDialog: false,
      voucherDetail: {}
    }
  },
  computed: {
    ...mapGetters({
      specialCasePaymentDialog: "TravellerSingle/special_case_payment_dialog",
    }),
  },
  watch: {
    amount(val) {
      this.usdAmount = val;
    },
    "paymentRef": function (val) {
      this.paymentData.payment_ref = val

    },
    usdAmount(usd) {
      // if (usd > 0 && usd - Math.floor(usd) === 0) {
      if (usd > 0 && usd) {
        this.nprAmount = (usd * this.npr_rate);
        this.nprAmount = (this.nprAmount - Math.floor(this.nprAmount) !== 0) ? this.nprAmount : this.nprAmount;
      }
    },
    "nprAmount": debounce(function (npr) {
      if (npr > 0) {
        this.usdAmount = (npr / this.npr_rate);
        this.usdAmount = (this.usdAmount - Math.floor(this.usdAmount) !== 0) ? this.usdAmount : this.usdAmount;
      }
    }, 1000)
  },
  async mounted() {
    Http.get(`${VERSIONED_API_URL}/get-npr-rate`).then((res) => {
      this.npr_rate = res.data
    })
  },
  methods: {
    async save() {
      if (this.$refs.manualRef.validate()) {
        try {
          this.loading = true;
          const formData = new FormData();
          if (this.paymentData.visa_number && this.paymentData.visa_number !== undefined)
            formData.append("visa_number", this.paymentData.visa_number);
          formData.append("title", this.paymentData.title);
          formData.append("type", this.paymentData.type);
          formData.append("amount_usd", this.usdAmount);
          formData.append("amount_npr", this.nprAmount);
          formData.append("revenue_date", this.paymentData.revenue_date);
          formData.append("remarks", this.paymentData.remarks);
          if (this.paymentData.payment_ref && this.paymentData.payment_ref !== undefined)
            formData.append("payment_ref", this.paymentData.payment_ref);
          if (this.paymentData.files !== undefined) {
            for (let i = 0; i < this.paymentData.files.length; i++) {
              formData.append(`files[${i}]`, this.paymentData.files[i])
            }
          }
          const response = await Http.post(`${VERSIONED_API_URL}/traveller/${this.travellerId}/generate-voucher-special-case-payment`, formData);
          this.$store.commit("TravellerSingle/setSpecialCasePaymentDialog", false);
          this.$store.commit("TravellerSingle/setSpecialCasePaymentVoucher", response.data);
          this.paymentData = {};
          // this.spcResponseDialog = true;
          this.voucherDetail = {
            submission_no: response.data.submission_no,
            voucher_no: response.data.voucher_no,
          };
          this.loading = false;
          this.$emit('input', false);
          this.$emit('vouchergenerated', response.data.cost)

        } catch (e) {
          console.log(e);
          this.loading = false;
          this.$store.commit('Notification/showError', e.response.data.message);
          this.errors = e.response.data.errors;
        }
      }
    },
    cancel() {
      this.paymentData = {};
      this.$store.commit("TravellerSingle/setSpecialCasePaymentDialog", false);
      this.$emit('input', false)
    }
  }
}
</script>

